import { useQuery } from "@bb-vendure/admin-ui/react";
import { gql } from "graphql-tag";

const GET_CUSTOMS_CLEARANCE_FILES = gql`
  query getCustomsClearanceFiles($id: ID!, $options: AssetListOptions) {
    getCustomsClearanceFiles(id: $id, options: $options) {
      totalItems
      items {
        id
        name
        source
        createdAt
        preview
      }
    }
  }
`;

export default function useGetCustomsClearanceFiles<T>(
  id: string,
  take: number,
  skip: number
) {
  return useQuery<T>(GET_CUSTOMS_CLEARANCE_FILES, {
    id: id,
    options: {
      take,
      skip,
      sort: {
        createdAt: "DESC",
      },
    },
  });
}
